// extracted by mini-css-extract-plugin
export default {"micro":"Micro-module__micro___JhwN6","bold":"Micro-module__bold___od7jC","muted":"Micro-module__muted___rdvz3","inline":"Micro-module__inline___vLkp7"};